export default __webpack_public_path__ + "static/media/check-circle.6349c1c1.svg";